import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ArticleGenerique } from "../article-generique/article-generique";
import { ArticleGeneriqueService } from "../article-generique/article-generique.service";

@Injectable({
    providedIn: 'root'
})
export class ArticleGeneriqueResolver {
    constructor(
        private articleGeneriqueService: ArticleGeneriqueService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ArticleGenerique> {
        return this.articleGeneriqueService.getArticleGenerique(route.params['code_article']);
    }

}
